import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import AuthProviderState from "./AuthProviderState";
import AppErrorBoundary from "./components/AppErrorBoundary";
import Container from "./components/layout/Container";
import PartnerProviderState from "./PartnerProviderState";
import ReactQueryProvider from "./ReactQueryProvider";

function App() {
  // TODO: throttle 적용
  // useEffect(() => {
  //   // css property 사용하여 ios 모바일에서 스크롤 생기는 문제 해결.
  //   let vh = window.innerHeight * 0.01;
  //   document.documentElement.style.setProperty("--vh", `${vh}px`);

  //   const setViewportHeightVariable = () => {
  //     let vh = window.innerHeight * 0.01;
  //     document.documentElement.style.setProperty("--vh", `${vh}px`);
  //   };

  //   window.addEventListener("resize", setViewportHeightVariable);

  //   return () => {
  //     window.removeEventListener("resize", setViewportHeightVariable);
  //   };
  // }, []);
  useEffect(() => {
    // 초기 높이 설정
    const updateViewportHeight = () => {
      let vh = window.visualViewport ? window.visualViewport.height * 0.01 : window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    // 초기 실행
    updateViewportHeight();

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", updateViewportHeight);
      window.visualViewport.addEventListener("scroll", updateViewportHeight);
    }

    window.addEventListener("resize", updateViewportHeight);

    document.addEventListener("visibilitychange", updateViewportHeight);
    window.addEventListener("orientationchange", updateViewportHeight);
    window.addEventListener("scroll", () => {
      setTimeout(updateViewportHeight, 100);
    });

    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", updateViewportHeight);
        window.visualViewport.removeEventListener("scroll", updateViewportHeight);
      }
      window.removeEventListener("resize", updateViewportHeight);
      document.removeEventListener("visibilitychange", updateViewportHeight);
      window.removeEventListener("orientationchange", updateViewportHeight);
      window.removeEventListener("scroll", updateViewportHeight);
    };
  }, []);

  return (
    <div className="App">
      <RecoilRoot>
        <BrowserRouter>
          <AppErrorBoundary>
            <AuthProviderState>
              <PartnerProviderState>
                <ReactQueryProvider>
                  <Container />
                </ReactQueryProvider>
              </PartnerProviderState>
            </AuthProviderState>
          </AppErrorBoundary>
        </BrowserRouter>
      </RecoilRoot>
    </div>
  );
}

export default App;
